<template>
    <CHeader id="header" position="sticky" class="mb-4">
        <CContainer fluid>
            <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')">
                <i class="fa fa-bars" aria-hidden="true"></i>
            </CHeaderToggler>
            <CHeaderBrand class="mx-auto d-lg-none" to="/">
                <img id="app-logo-header" :src="logoActual" style="max-width: 100px; margin: auto;">
            </CHeaderBrand>
            <CHeaderNav class="d-none d-md-flex me-auto">
                <!--<CNavItem>
                    <CNavLink href="/dashboard"> Dashboard</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink href="#">Users</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink href="#">Settings</CNavLink>
                </CNavItem>-->
            </CHeaderNav>
            <CHeaderNav>
                <AppHeaderDropdownAccnt />
            </CHeaderNav>
            <CHeaderNav class="header__nav-items">
                <!--<CNavItem>
                    <CNavLink href="#">
                        <CIcon class="mx-2" icon="cil-bell" size="lg"/>
                    </CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink href="#">
                        <CIcon class="mx-2" icon="cil-list" size="lg"/>
                    </CNavLink>
                </CNavItem>-->
                <CNavItem>
                    <CNavLink @click="$router.push('/ver/noticias')" class="text-success">
                        <i class="far fa-lightbulb fa-lg"></i>
                    </CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink   @click="$router.push('/ver/ayuda')">
                        <i class="far fa-question-circle fa-lg"></i>
                    </CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink  @click="$router.push('/ver/promociones')">
                        <i class="fa-solid fa-comment-dollar"></i>
                    </CNavLink>
                </CNavItem>
                <button id="header__btn-logout" class="btn btn-secondary btn__logout" @click="logout">
                    <i class="fas fa-lock"/>
                    <span class="d-none d-sm-inline-block ms-2">Cerrar sesión</span>
                </button>
            </CHeaderNav>
        </CContainer>
        <CHeaderDivider/>
        <CContainer fluid>
            <AppBreadcrumb/>
        </CContainer>
    </CHeader>
</template>

<script>
import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import {logo} from '@/assets/brand/logo'
import {mapMutations} from "vuex";
import toolbox from "@/toolbox";
import Swal from "sweetalert2";
import {mapGetters} from "vuex";
import {ref, onMounted} from 'vue'
import {config} from '@/config'
import logoDefault from '@/assets/images/logo-dark.png'


export default {
    name: 'AppHeader',
    components: {
        AppBreadcrumb,
        AppHeaderDropdownAccnt,
    },
    setup() {
        const logoActual = ref(logoDefault)

        onMounted(async () => {
            try {
                const response = await fetch(`${config.backendUrl}/personalizacion/public`)
                if (response.ok) {
                    const data = await response.json()
                    if (data.status && data.data && data.data.logo) {
                        logoActual.value = data.data.logo
                    }
                }
            } catch (error) {
                console.warn('No se pudo cargar logo personalizado en header:', error)
            }
        })

        return {
            logo,
            logoActual,
        }
    },
    computed: {
        ...mapGetters({
            authLogged: 'authLogged',
            authInfo: 'authInfo',
        }),

    },
    methods: {
        ...mapMutations(["authSetInfo"]),
        logout() {

            const self = this;

                Swal.fire({
                title: '¿Deseas cerrar sesión en todas las aplicaciones?',
                showCancelButton: true,
                confirmButtonText: 'Solo en esta aplicación',
                cancelButtonText: `Cerrar todo`,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn__limpiar me-3',
                    cancelButton: 'btn btn__cancelar'
                },
                }).then((result) => {
                toolbox.doAjax('POST', 'auth/logout', {
                        type: (!result.isConfirmed ? 'all' : '')
                    },
                    function (response) {
                        self.authSetInfo({});
                        self.$router.push('/login');
                    },
                    function (response) {
                        toolbox.alert(response.msg, 'danger');
                    })
            })

        },
        help() {

            const self = this;
            self.$router.push('/help');
            //loginClose

        }
    }
}
</script>
